module.exports = __webpack_public_path__ + "static/media/Logo__Addigy.50ddc87d.svg";